import $ from 'jquery';

const OPEN_CLASS = 'active';
const MIN_DEVICE_WIDTH_FOR_SCALE = 1024;

class MobileMainNav {

  constructor($main) {
    if (!this.initDomElements($main)) return false;

    this.initToggles();
    // this.initScaleElements();
    // this.scaleElements();
  }

  initToggles() {
    this.domElements.toggles.on('click', event => {
      event.preventDefault();

      const toggle = $(event.currentTarget);
      const parentLi = toggle.closest('li');
      const parentUl = toggle.closest('ul');

      parentUl.find('li').each((index, element) => {
        const li = $(element);
        if (li[0] === parentLi[0]) {
          li.toggleClass(OPEN_CLASS);
        } else {
          li.removeClass(OPEN_CLASS);
        }
      });
    });
  }

  initScaleElements() {
    $(window).on('resize', this.scaleElements.bind(this));
  }

  scaleElements() {

    const ulWidth = this.domElements.main.outerWidth() / 3;

    if (this.domElements.window.outerWidth() >= MIN_DEVICE_WIDTH_FOR_SCALE) {
      const ulWidth = this.domElements.main.outerWidth() / 3;
      this.domElements.level2Ul.css({width: ulWidth + 'px'});
      this.domElements.level3Ul.css({width: ulWidth + 'px', left: ulWidth + 'px'});
      this.domElements.level4Ul.css({width: ulWidth + 'px', left: ulWidth + 'px'});
    } else {
      this.domElements.level2Ul.css({width: ''});
      this.domElements.level3Ul.css({width: '', left: ''});
      this.domElements.level4Ul.css({width: '', left: ''});
    }
  }

  initDomElements($main) {
    this.domElements = {};
    this.domElements.main = $main;
    if (this.domElements.main.length < 1) return false;

    this.domElements.window = $(window);

    this.domElements.toggles = this.domElements.main.find(
        'li.sub > a');

    this.domElements.level1Ul = this.domElements.main.find('.main-nav__level-1');
    this.domElements.level2Ul = this.domElements.main.find('.main-nav__level-2');
    this.domElements.level3Ul = this.domElements.main.find('.main-nav__level-3');
    this.domElements.level4Ul = this.domElements.main.find('.main-nav__level-4');

    return true;
  }

}

export default MobileMainNav;
